import EquipmentItem from "./EquipmentItem";

export default EquipmentItem;
